import { ButtonVariant, CoButton } from "components/CoButton";
import pluralize from "helpers/pluralize";
import useLabels from "hooks/useLabels";

type ApplyFooterProps = {
  onRemoveAllFilters: () => void;
  onDone: () => void;
  pendingFiltersCount: number;
};

function ApplyFooter({
  onRemoveAllFilters,
  onDone,
  pendingFiltersCount,
}: ApplyFooterProps) {
  const [filterLabels] = useLabels("filter");

  return (
    <div className="w-full flex flex-col gap-2 justify-between sm:flex-row">
      <CoButton
        onClick={onDone}
        variant={ButtonVariant.Primary}
        className="flex-1"
        size="sm"
        label={pluralize(filterLabels["apply-x-filters"], {
          FILTER_COUNT: pendingFiltersCount,
        })}
      />
      <CoButton
        onClick={onRemoveAllFilters}
        variant={ButtonVariant.Tertiary}
        size="sm"
        label={filterLabels["reset-filters"]}
      />
    </div>
  );
}

export default ApplyFooter;
